function getOpenedBracketsOrQuotes(str) {
  const stack = []
  const map = {
    '{': '}',
    '[': ']',
    '"': '"'
  }

  for (let i = 0; i < str.length; i++) {
    if (str[i] === '"') {
      if (stack[stack.length - 1] === '"') {
        stack.pop()
      } else {
        stack.push(str[i])
      }
    } else if (str[i] === '{' || str[i] === '[') {
      stack.push(str[i])
    } else if (str[i] === '}' || str[i] === ']') {
      let last = stack.pop()
      if (str[i] !== map[last]) {
        return []
      }
    }
  }
  return stack
}

function closeBracketsOrQuotes(openBracketsOrQuotes) {
  let map = {
    '"': '"',
    '{': '}',
    '[': ']'
  }

  let closingBracketsOrQuotes = openBracketsOrQuotes.reverse().map(bracketOrQuote => map[bracketOrQuote])

  return closingBracketsOrQuotes
}

function fixSyntax(brokenCode) {
  // const find all opened brackets and quotes which are not closed
  const openedBrackets = getOpenedBracketsOrQuotes(brokenCode)
  // find the closing brackets and quotes in the opposite order to the opened ones
  const closedBrackets = closeBracketsOrQuotes(openedBrackets)

  // add missing closing brackets and quotes to the end of the string to make the json valid
  return brokenCode + closedBrackets.join('')
}

export function fixJSON(jsonString) {
  // Trim the string to remove extra spaces and newlines
  const trimmedString = jsonString.trim()

  // Add closing double-quote and curly brace to make it valid JSON
  // just a note it doesn't return valid JSON every time
  // but it's enough to the frequency the server sends data to support typing
  return fixSyntax(trimmedString)
}
